import { useState } from 'react'
import { Link, Navigate } from 'react-router-dom'

import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import { getFetchError } from '@/reducers/fetch'
import {
  SEND_RESET_PASSWORD_EMAIL_KEY,
  sendResetPasswordEmail,
} from '@/actions/authActions'
import { TypographyStyles } from '@/styles'
import { Text, Alert, Image, Input, Button, Card } from '@/ui'

const transformErrorMessage = (message: string) =>
  message === 'email must be unique'
    ? 'An account already exists with this email.'
    : message

export const ResetPassword = () => {
  const [email, setEmail] = useState('')
  const auth = useReselector((state) => state.auth.security)
  const dispatch = useAppDispatch()

  const error = useReselector((state) =>
    getFetchError(state, SEND_RESET_PASSWORD_EMAIL_KEY)
  )

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    dispatch(sendResetPasswordEmail({ email: email.toLowerCase() }))
  }

  if (auth.isAuthenticated) {
    return <Navigate to="/dashboard" />
  }

  if (auth.resetPasswordEmailSent) {
    return (
      <div className="w-full pt-12 finances reset">
        <Text variant={TypographyStyles.H2}>Please check your email!</Text>

        <Text variant={TypographyStyles.BODY_MD}>
          We&#39;ve sent over a link that you will use to reset your password.
        </Text>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center w-full pt-12 finances reset">
      <Image
        src="https://heard-images.s3.us-west-1.amazonaws.com/heard_logo_green_2x.png"
        alt="heard logo"
        height={20}
        width={100}
      />

      <Text variant={TypographyStyles.H2} className="mt-4">
        Reset Your Password
      </Text>

      <div className="w-full md:w-3/4 lg:w-5/12">
        <Card>
          <form className="flex flex-col space-y-4" onSubmit={handleSubmit}>
            {error && (
              <Alert variant="error">
                {transformErrorMessage(error.message)}
              </Alert>
            )}

            <Input
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button
              id="btn-auth-reset-password-email"
              type="submit"
              disabled={!email}
            >
              Send Reset Email
            </Button>
          </form>
        </Card>

        <Link to="/login">Return to login</Link>
        <Link to="/auth/reset" />
      </div>
    </div>
  )
}
